import { createContext } from 'react';

type RadioButtonGroupContextType = {
  name?: string;
  value?: string;
  onChange?: (selectedValue: string) => void;
};

export const radioButtonGroupContext = createContext<RadioButtonGroupContextType>({});
